import apiEndpoints from "../config/apiEndpoints";
import axiosInstance from "../api/axiosInstance";
import { logInfo, captureError, captureEvent } from "../utils/sentryUtils";

export const getFeedback = async (key, lang, type) => {
  if (!key || !lang || !type) {
    captureError(new Error("getFeedback: key, lang, or type is missing"), {
      function: "getFeedback",
      key,
      lang,
      type,
    });
    console.error("key, lang, and type are required");
    return null;
  }
  logInfo("Fetching feedback", { key, lang, type });
  try {
    const response = await axiosInstance.get(apiEndpoints.GET_FEEDBACK(key, lang, type));
    captureEvent("getFeedback.success", { key, lang, type });
    return response;
  } catch (error) {
    captureError(error, {
      function: "getFeedback",
      "api.status": error?.response?.status,
      "api.url": error?.config?.url,
      key,
      lang,
      type,
    });
    console.error("Error fetching feedback", error?.message);
    return null;
  }
};

export const createEnquete = async (data) => {
  if (!data) {
    captureError(new Error("createEnquete: data payload is missing"), {
      function: "createEnquete",
    });
    console.error("data is required");
    return null;
  }
  logInfo("Creating enquete (feedback submission)", {});
  try {
    const response = await axiosInstance.post(apiEndpoints.CREATE_FEEDBACK, data);
    captureEvent("createEnquete.success", {});
    return response;
  } catch (error) {
    captureError(error, {
      function: "createEnquete",
      "api.status": error?.response?.status,
      "api.url": error?.config?.url,
      "api.responseData": error?.response?.data,
    });
    console.error("Error creating Feedback:", error?.message);
    return null;
  }
};